import { v4 as uuidv4 } from "uuid"
import ActualPricesLotTab from "./Accounting/ActualPricesLot/ActualPricesLotTab";
import AnalysisLotTab from "./Accounting/AnalysisLot/AnalysisLotTab";
import CashSessionTab from "./Accounting/CashSession/CashSessionTab";
import ChequeGridTab from "./Accounting/Cheque/ChequeGrid/ChequeGridTab";
import ChequeTab from "./Accounting/Cheque/ChequeViewTab";
import ChequeItemTab from "./Accounting/Cheque/Components/ChequeItem/ChequeItemTab";
import ChequeKizTab from "./Accounting/Cheque/Components/ChequeKiz/ChequeKizTab";
import DefecturaTab from "./Accounting/Defectura/DefecturaViewTab";
import { InternetOrderCreatorTab } from "./Accounting/InternetOrder/InternetOrderCreator/InternetOrderCreatorTab";
import InternetOrderItemsTab from "./Accounting/InternetOrder/InternetOrderItems/InternetOrderItemsTab";
import InternetOrderTab from "./Accounting/InternetOrder/InternetOrderTab";
import { InventorySvedCreatorTab, InventorySvedGridTab, InventorySvedItemTab } from "./Accounting/InventorySved";
import { InventoryVedGridTab, InventoryVedItemFormTab } from "./Accounting/InventoryVed";
import InventoryVedFormTab from "./Accounting/InventoryVed/inventoryVedFormTab";
import InventoryVedItemGridTab from "./Accounting/InventoryVed/inventoryVedItemGridTab";
import { KizExchangeCreatorTab } from "./Accounting/KizExchangeCreatorModal";
import KizExchangeDetailedTab from "./Accounting/KizExchangeDetailedGridPluginSettings/KizExchangeDetailedTab";
import { KizExchangeTab, KizExchangeTabByLot } from "./Accounting/KizExchangeStatus";
import {
    KizInventoryCreatorTab,
    KizInventoryGridTab,
    KizInventoryItemAddTab,
    KizInventoryItemCorrectStatusTab,
    KizInventoryItemMisTab,
    KizInventoryItemOldTab,
    KizInventoryItemSubTab,
    KizInventoryItemTab,
} from "./Accounting/KizInventory";
import { KizInventoryItem511SchemaTab } from "./Accounting/KizInventory/tabs/KizInventoryItem511SchemaTab";
import { KizInventoryItem552SchemaTab } from "./Accounting/KizInventory/tabs/KizInventoryItem552SchemaTab";
import { KizInventoryItemProblemTab } from "./Accounting/KizInventory/tabs/KizInventoryItemProblemTab";
import { LotMovementCreatorTab } from "./Accounting/LotMovement";
import { LotsTab, LotsDetailForLotsByGoodsTab } from "./Accounting/Lots";
import { LotsByGoodsTab } from "./Accounting/LotsByGoods";
import { LotsByLotsTab } from "./Accounting/LotsByLots";
import { BarcodeTab } from "./Dictionaries/Barcode";
import { ContractorTab } from "./Dictionaries/Contractor";
import { InvoiceSettingsCreatorTab } from "./Dictionaries/Contractor/invoiceSettings/InvoiceSettingsCreator/InvoiceSettingsCreatorTab";
import { CountryTab } from "./Dictionaries/Country/CountryTab";
import { CureFormTab, CureFormTabView } from "./Dictionaries/CureForm";
import { DeductionReasonTab } from "./Dictionaries/DeductionReason";
import DiscountCardCreatorTab from "./Dictionaries/DiscountCard/DiscountCardCreator/DiscountCardCreatorTab";
import DiscountCardFormTab from "./Dictionaries/DiscountCard/DiscountCardFormTab";
import DiscountCardTypeCreatorTab from "./Dictionaries/DiscountCardType/DiscountCardTypeCreator/DiscountCardTypeCreatorTab";
import { DiscountCardTypeFormTab } from "./Dictionaries/DiscountCardType/DiscountCardTypeFormTab";
import DiscountMemberFormTab from "./Dictionaries/DiscountMember/DiscountMemberFormTab";
import DiscountProgramTab from "./Dictionaries/DiscountProgram/DiscountProgramCreator/DiscountProgramTab";
import DiscountProgramFormTab from "./Dictionaries/DiscountProgram/DiscountProgramFormTab";
import FalsificatTab from "./Dictionaries/Falsificat/FalsificatTab";
import { GoodsTab } from "./Dictionaries/Goods";
import { GoodsClassifierItemsTab } from "./Dictionaries/GoodsClassifier/tabs/GoodsClassifierItemsTab";
import { GoodsClassifierTab } from "./Dictionaries/GoodsClassifier/tabs/GoodsClassifierTab";
import { GoodsCodeTab, GoodsCodeViewTab } from "./Dictionaries/GoodsCode";
import GoodsKindFormTab from "./Dictionaries/GoodsKind/GoodsKindFormTab";
import { GosContractItemsTab } from "./Dictionaries/GosContract/tabs/GosContractItemsTab";
import { GosContractCreateTab } from "./Dictionaries/GosContract/tabs/GosContractorCreateTab";
import { GosContractTab } from "./Dictionaries/GosContract/tabs/GosContractTab";
import { GosContractFundingSourceTab } from "./Dictionaries/GosContractFundingSource/tabs/GosContractFundingSourceTab";
import { KizTab } from "./Dictionaries/Kiz";
import { KizViewTab } from "./Dictionaries/Kiz/KizView/KizViewTab";
import PaletteBoxTab from "./Dictionaries/Kiz/ScanModal/box/PaletteBoxTab";
import ScanBoxTab from "./Dictionaries/Kiz/ScanModal/box/ScanBoxTab";
import ScanKizOsuTab from "./Dictionaries/Kiz/ScanModal/kizOsu/ScanKizOsuTab";
import { LegalEntityTab } from "./Dictionaries/LegalEntity";
import PricingAdpriceScaleItemTab from "./Dictionaries/PricingAdpriceScale/tabs/PricingAdpriceScaleItemTab";
import { PricingExtremeAdpriceSchemaItemTab } from "./Dictionaries/PricingExtremeAdpriceSchema/tabs/PricingExtremeAdpriceSchemaItemTab";
import { PricingFormulaTab } from "./Dictionaries/PricingFormula/PricingFormulaTab";
import { PricingMinAdpriceSchemaItemTab } from "./Dictionaries/PricingMinAdpriceSchema/tabs/PricingMinAdpriceSchemaItemTab";
import { PricingModelTab } from "./Dictionaries/PricingModel";
import { PricingModelCreateTab } from "./Dictionaries/PricingModel/tabs/PricingModelCreateTab";
import { PricingPriceCalcSchemaItemTab } from "./Dictionaries/PricingPriceCalcSchema/tabs/PricingPriceCalcSchemaItemTab";
import { PricingRoundScaleItemTab } from "./Dictionaries/PricingRoundScale/tabs/PricingRoundScaleItemTab";
import { ProducerTab } from "./Dictionaries/Producer";
import RegisterPriceTab from "./Dictionaries/RegisterPrice/RegisterPriceTab";
import { ScalingRatioTab } from "./Dictionaries/ScalingRatio";
import { StoreTab } from "./Dictionaries/Store";
import StoreTabDetail from "./Dictionaries/Store/StoreTabDetail";
import { StoreTypeTab } from "./Dictionaries/StoreType";
import { SubstanceTab } from "./Dictionaries/Substance";
import TaskProgramFormTab from "./Dictionaries/TaskProgram/TaskProgramFormTab";
import TaskProgramItemTab from "./Dictionaries/TaskProgram/TaskProgramItem/TaskProgramItemTab";
import { TaxTypeTab } from "./Dictionaries/TaxType";
import { TradeNameTab } from "./Dictionaries/TradeName";
import { UnitTab } from "./Dictionaries/Unit";
import ActDeductionCreatorTab from "./Documents/ActDeduction/tabs/ActDeductionCreatorTab";
import ActDeductionItemTab from "./Documents/ActDeduction/tabs/ActDeductionItemTab";
import { ActDeductionTab } from "./Documents/ActDeduction/tabs/ActDeductionTab";
import ActDisagregationCreatorTab from "./Documents/ActDisagregation/ActDisagregationCreator/ActDisagregationCreatorTab";
import ActDisagregationItemTab from "./Documents/ActDisagregation/ActDisagregationItem/ActDisagregationItemTab";
import ActDisagregationTab from "./Documents/ActDisagregation/ActDisagregationTab";
import ActDisassemblingCreatorTab from "./Documents/ActDisassembling/ActDisassemblingCreator/ActDisassemblingCreatorTab";
import ActDisassemblingItemTab from "./Documents/ActDisassembling/ActDisassemblingItem/ActDisassemlingItemTab";
import ActDisassemblingTab from "./Documents/ActDisassembling/ActDisassemblingTab";
import { ActReturnToContactorTab } from "./Documents/ActReturnToContractor/tabs/ActReturnToContactorTab";
import { ActReturnToContactorCreateTab } from "./Documents/ActReturnToContractor/tabs/ActReturnToContractorCreateTab";
import ActReturnToContractorItemTab from "./Documents/ActReturnToContractor/tabs/ActReturnToContractorItemTab";
import ActRevaluationCreatorTab from "./Documents/ActRevaluation/ActRevaluationCreator/ActRevaluationCreatorTab";
import ActRevaluationItemTab from "./Documents/ActRevaluation/ActRevaluationItemGrid/ActRevaluationItemTab";
import ActRevaluationTab from "./Documents/ActRevaluation/ActRevaluationTab";
import BunchInvoicesTab from "./Documents/ImportInvoices/BunchInvoices/BunchInvoicesTab";
import ImportInvoicesTab from "./Documents/ImportInvoices/ImportInvoicesTab";
import ImportRemainsItemCreatorTab from "./Documents/ImportRemains/ImportRemainsCreator/ImportRemainsItemCreator/ImportRemainsItemCreatorTab";
import { GlobalImportInvoicesTab } from "./Documents/GlobalImportInvoices/GlobalImportInvoicesTab";
import { ImportedInvoiceItemTab } from "./Documents/GlobalImportInvoices/ImportedInvoiceItemTab";
import { ImportRemainsCreatorTab, ImportRemainsItemTab } from "./Documents/ImportRemains/ImportRemainsItem";
import { ImportRemainsTab } from "./Documents/ImportRemains/Index";
import { InvoiceCreatorTab, InvoiceTab } from "./Documents/Invoice";
import { InvoiceItemCreatorTab, InvoiceItemTab } from "./Documents/Invoice/InvoiceItem";
import { InvoiceOutCreatorTab, InvoiceOutItemTab, InvoiceOutTab } from "./Documents/InvoiceOut";
import { MovementCreatorTab } from "./Documents/Movement/MovementCreator/MovementCreatorTab";
import { MovementFromRequestCreatorTab } from "./Documents/Movement/MovementCreator/MovementFromRequest/MovementFromRequestCreatorTab";
import { MovementCreationTab } from "./Documents/Movement/MovementCreator/MovementFromRequest/MovementCreationTab";
import MovementItemsTab from "./Documents/Movement/MovementItems/MovementItemsTab";
import MovementTab from "./Documents/Movement/MovementTab";
import { RequestForMovementCreatorTab } from "./Documents/RequestForMovement/RequestForMovementCreator/RequestForMovementCreatorTab";
import { RequestForMovementItemsTab } from "./Documents/RequestForMovement/RequestForMovementItems/RequestForMovementItemsTab";
import { RequestForMovementTab } from "./Documents/RequestForMovement/RequestForMovementTab";
import { ImportExternalReportTab } from "./ImportFile/ImportRemain/tabs/importExternalReportTab";
import { ImportRemainTab } from "./ImportFile/ImportRemain/tabs/importRemainTab";
import { ReportListCreatorTab } from "./Reports/ReportListCreator/ListCreatorTab";
import { ReportsMenuTab } from "./Reports/ReportMenuTab";
import { ReportViewerTab } from "./Reports/ReportViewerTab";
import { AboutTab } from "./Service/About";
import { AccessPointDetailTab } from "./Service/AccessPoint/AccessPointDetail/AccessPointDetailTab";
import { AccessPointTab } from "./Service/AccessPoint/AccessPointTab";
import CashRegistersTab from "./Service/CashRegisters/CashRegistersTab";
import BunchDbTab from "./Service/CashRegisters/components/ModalWindow/BunchDB/BunchDbTab";
import SettingsAdditionalTab from "./Service/CashRegisters/components/ModalWindow/SettingsAdditional/SettingsAdditionalTab";
import { BasicSettingsTab } from "./Service/CodeControl/tabs/BasicSettingsTab";
import { ProductGroupsGISMTTab } from "./Service/CodeControl/tabs/ProductGroupsGISMTTab";
import { RegKeysListTab } from "./Service/CodeControl/tabs/RegKeysListTab";
import { SettingsOfflineTab } from "./Service/CodeControl/tabs/SettingsOfflineTab";
import { SettingTimeTab } from "./Service/CodeControl/tabs/SettingTimeTab";
import CompaniesTab from "./Service/Companies/CompaniesTab";
import CompanyActiveSessionsTab from "./Service/CompanyActiveSessions/CompanyActiveSessionsTab";
import { ConnectionSettingsF3lloTab } from "./Service/ConnectionSettingsF3llo/tabs/ConnectionSettingsF3lloTab";
import { ConstructorSchemesTab } from "./Service/ConstructorSchemes/tabs/ConstructorSchemesTab";
import { ContractorTaxTypePluginTab } from "./Service/Contractor/ContractorTaxTypePluginTab";
import ConditionTab from "./Service/DiscountConditionType/ConditionTab";
import DisposalRegistrarTab from "./Service/DisposalRegistrar/DisposalRegistrarTab";
import { EsCodeViewPluginTab } from "./Service/EsCode/EsCodeTab";
import ImportPricingModelViewTab from "./Service/ImportPricingModel/ImportPricingModelViewTab";
import { KizFilesViewPluginTab } from "./Service/KizServerFiles/KizFilesViewPluginTab";
import { LabelDesignerTab } from "./Service/LabelDesigner/LabelDesignerTab";
import { LabelDesignerTemplateTab } from "./Service/LabelDesignerTemplate/LabelDesignerTemplateTab";
import { LabelPrintScenarioTab } from "./Service/LabelPrintScenario/LabelPrintScenarioTab";
import LockingDocumentsTab from "./Service/LockingDocuments/LockingDocumentsTab";
import RoleTab from "./Service/Role/RoleTab";
import RoleLocalTab from "./Service/RoleLocal/RoleLocalTab";
import SysOptionsDetailTab from "./Service/SysOptions/components/detailGrid/SysOptionsDetailTab";
import SysOptionsTab from "./Service/SysOptions/SysOptionsTab";
import { SystemTestViewPluginTab } from "./Service/SystemTest/SystemTestViewPluginTab";
import TestPricingModelTab from "./Service/TestPricingModel/tabs/TestPricingModelTab";
import { UserTab } from "./Service/User/tabs/UserTab";
import UserActionLogTab from "./Service/UserActionLog/tabs/UserActionLogTab";
import { UserLocalTab } from "./Service/UserLocal/tabs/UserLocalTab";
import { VirtualizedTab } from "./Service/Virtualized/tabs/VirtualizedTab";
import { ImportMarketContractTab } from './ImportFile/ImportRemain/tabs/importMarketContractTab';
import KizMarkTab from './Service/KizMark/KizMarkTab';
import InvoiceCashOrderTab from "./Documents/InvoiceCashOrder/tabs/InvoiceCashOrderTab";
import { InvoiceCashOrderCreatorTab } from "./Documents/InvoiceCashOrder/tabs/InvoiceCashOrderCreatorTab";
import ChequeKizMarkTab from './Accounting/Cheque/Components/ChequeKizMark/ChequeKizMarkTab';
import DashboardBusinessControlsTab from './Accounting/DashboardBusinessControls/DashboardBusinessControlsTab';
import { ExportDocumentToolsCreateTab } from './Service/ExportDocumentTools/tabs/ExportDocumentToolsCreateTab';
import ExportDocumentToolsTab from './Service/ExportDocumentTools/ExportDocumentToolsTab';
import { Export1CTab } from "./ImportFile/Export1C/tabs/Export1CTab";
import { Export1CProcedureTab } from "./Service/Export1CProcedure";
import { LabelPrintScenarioItemsTab } from "./Service/LabelPrintScenario/LabelPrintScenarioItems/LabelPrintScenarioItemsTab";
import GoodsGroupByGoodTab from "./Dictionaries/GoodsGroup/GoodsGroupByGoodTab";
import { LoyaltyProgramTab } from "./Service/LoyaltyProgram/LoyaltyProgramTab";
import AnalysisSalesLotTab from "./Accounting/AnalysisSalesLot/AnalysisSalesLotTab";
import AnalysisWithoutSalesLotTab from "./Accounting/AnalysisWithoutSalesLot/AnalysisWithoutSalesLotTab";
import { ScanBoxGismtTab } from "./Dictionaries/Kiz/ScanModal/boxGismt/ScanBoxGismtTab";
import { ConnectionSettingsMarketingEventsTab } from "./Service/ConnectionSettingsMarketingEvents/tabs/ConnectionSettingsMarketingEventsTab"; 
import { MarketingEventsTab } from "./Dictionaries/MarketingEvents/MarketingEventsTab";
import { MarketingEventsProductsTab } from "./Dictionaries/MarketingEvents/MarketingEventsProducts/MarketingEventsProductsTab";
import { MarketingEventsPlanDepartmentsTab } from "./Dictionaries/MarketingEvents/MarketingEventsPlanDepartments/MarketingEventsPlanDepartmentsTab";
import { MarketingEventsFactDepartmentsTab } from "./Dictionaries/MarketingEvents/MarketingEventsFactDepartments/MarketingEventsFactDepartmentsTab";
import { MarketingEventsDistributorsTab } from "./Dictionaries/MarketingEvents/MarketingEventsDistributors/MarketingEventsDistributorsTab";
import { MarketingEventsDepartmentsTab } from "./Dictionaries/MarketingEvents/MarketingEventsDepartments/MarketingEventsDepartmentsTab";
import { MarketingCompensatedDiscountsTab } from "./Dictionaries/MarketingCompensatedDiscounts/MarketingCompensatedDiscountsTab";
import { MarketingCompensatedDiscountsProductsTab } from "./Dictionaries/MarketingCompensatedDiscounts/MarketingCompensatedDiscountsProducts/MarketingCompensatedDiscountsProductsTab";
import RequestForMovementPartyTab from "./Documents/RequestForMovement/RequestForMovementItems/RequestForMovementPartyTab";
import { CreateDefaultPluginSettingsTab } from "./Service/DefaultPluginSettings/tabs/CreateDefaultPluginSettingsTab";
import BarcodeGridViewTab from "./Dictionaries/Barcode/BarcodeGrid/BarcodeGridViewTab";
import { KizViewInventorySvedTab } from "./Dictionaries/Kiz/KizView/KizViewInventorySvedTab";
import KizBoxInventorySvedTab from "./Dictionaries/Kiz/ScanModal/box/KizBoxInventorySvedTab";
import StorePlaceTab from "./Dictionaries/StorePlace/StorePlaceTab";
import EmployeeTab from "./Dictionaries/Employee/EmployeeTab";
import { NewsMakerTab } from "./Service/NewsMaker/NewsMakerTab";
import { BasePhotoDownloadTab } from "./Service/BasePhotoDownload/BasePhotoDownloadTab";
import { ConnectionSettingsF3busTab } from "./Service/ConnectionSettingsF3bus/tabs/ConnectionSettingsF3busTab";
import FinancialSecurityTab from "./Dictionaries/FinancialSecurity/FinancialSecurityTab";
import { CategoricalGroupTab } from "./Dictionaries/CategoricalGroup/CategoricalGroupTab";
import { MarketingBonusCalculatorTab } from "./Service/MarketingBonusCalculator/MarketingBonusCalculatorTab";

export type CreateVariant = "create" | "edit" | "copy" | "view" | "test";

export class MasterTabsProvider {
    public static Create(plugin: IPlugin, variant?: CreateVariant, idGlobal?: string, parentCallback?: <T>(message?: T) => void, data?: any, singleRender?: boolean): ITab {
        switch (plugin) {
            case "tax_type_plugin":
                return TaxTypeTab(variant);
            case "country_plugin":
                return CountryTab();
            case "deduction_reason_plugin":
                return DeductionReasonTab();
            case "producer_plugin":
                return ProducerTab();
            case "substance_plugin":
                return SubstanceTab();
            case "store_place_plugin":
                return StorePlaceTab();
            case "financial_security_plugin":
                return FinancialSecurityTab();
            case "cure_form_plugin":
                return CureFormTab();
            case "cure_form_plugin_view":
                return CureFormTabView(variant);
            case "legal_entity_plugin":
                return LegalEntityTab();
            case "contractor_plugin":
                return ContractorTab();
            case "goods_plugin":
                return GoodsTab(variant, singleRender);
            case "goods_classifier_plugin":
                return GoodsClassifierTab();
            case "goods_classifier_items_plugin":
                return GoodsClassifierItemsTab();
            case "store_type_plugin":
                return StoreTypeTab();
            case "trade_name_plugin":
                return TradeNameTab(variant);
            case "store_plugin":
                return StoreTab();
            case "store_plugin_detail":
                return StoreTabDetail();
            case "report_plugin":
                return ReportViewerTab(data, idGlobal);
            case "reports_material_plugin":
                return ReportsMenuTab(plugin);
            case "reports_product_plugin":
                return ReportsMenuTab(plugin);
            case "reports_cash_plugin":
                return ReportsMenuTab(plugin);
            case "reports_withoutGroup_plugin":
                return ReportsMenuTab(plugin);
            case "reports_accounting_plugin":
                return ReportsMenuTab(plugin);
            case "reports_analisys_plugin":
                return ReportsMenuTab(plugin);
            case "goods_code_plugin":
                return GoodsCodeTab();
            case "goods_code_plugin_view":
                return GoodsCodeViewTab(variant);
            case "kiz_view_plugin":
                return KizViewTab();
            case "kiz_view_inventory_sved_plugin":
                return KizViewInventorySvedTab();
            case "scan_box_plugin":
                return ScanBoxTab();
            case "kiz_box_inventory_sved_plugin":
                return KizBoxInventorySvedTab();
            case "scan_kiz_osu_plugin":
                return ScanKizOsuTab();
            case "create_modal_box_gismt_plugin":
                return ScanBoxGismtTab();
            case "palette_box_plugin":
                return PaletteBoxTab();
            case "kiz_plugin":
                return KizTab();
            case "kiz_exchange_plugin":
                return KizExchangeTab(data);
            case "kiz_exchange_detailed_plugin":
                return KizExchangeDetailedTab();
            case "kiz_exchange_modal_plugin":
                return KizExchangeCreatorTab(variant, idGlobal, parentCallback, data);
            case "kiz_exchange_tab_plugin":
                return KizExchangeTabByLot(idGlobal ?? "", data?.goodsCode ?? "", data?.goodsName ?? "");
            case "invoice_plugin":
                return InvoiceTab(variant);
            case "invoice_item_plugin":
                return InvoiceItemTab();
            case "invoice_creator_plugin":
                return InvoiceCreatorTab(variant, idGlobal, parentCallback, data);
            case "invoice_item_creator_plugin":
                return InvoiceItemCreatorTab(data, parentCallback);
            case "pricing_model_plugin":
                return PricingModelTab();
            case "pricing_model_create_plugin":
                return PricingModelCreateTab(variant, idGlobal, data, parentCallback);
            case "pricing_adprice_scale_plugin":
                return PricingAdpriceScaleItemTab();
            case "pricing_round_scale_plugin":
                return PricingRoundScaleItemTab();
            case "pricing_extreme_adprice_schema_plugin":
                return PricingExtremeAdpriceSchemaItemTab();
            case "pricing_min_adprice_schema_plugin":
                return PricingMinAdpriceSchemaItemTab();
            case "pricing_price_calc_schema_plugin":
                return PricingPriceCalcSchemaItemTab();
            case "scaling_ratio_plugin":
                return ScalingRatioTab();
            case "lots_by_lots_plugin":
                return LotsByLotsTab();
            case "lots_by_goods_plugin":
                return LotsByGoodsTab();
            case "analysis_lot_plugin":
                return AnalysisLotTab(variant, idGlobal, data?.tabId, data?.contractorName, data?.reportType);          
            case "dashboard_business_controls_plugin":
                return DashboardBusinessControlsTab();
            case "analysis_sales_lot_plugin":
                return AnalysisSalesLotTab(variant, idGlobal, data?.tabId, data?.contractorName, data?.reportType);
            case "analysis_withOut_sales_lot_plugin":
                return AnalysisWithoutSalesLotTab(variant, idGlobal, data?.tabId, data?.contractorName, data?.reportType);
            case "actual_prices_lot_plugin":
                return ActualPricesLotTab(variant, idGlobal, data?.tabId, data?.contractorName, data?.reportType);
            case "lot_plugin":
                return LotsTab();
            case "lot_detail_for_lots_by_goods_plugin":
                return LotsDetailForLotsByGoodsTab();
            case "lot_movement_plugin":
                return LotMovementCreatorTab(variant, idGlobal, data, parentCallback);
            case "import_invoices_plugin":
                return ImportInvoicesTab();
            case "import_pricing_model_plugin":
                return ImportPricingModelViewTab();
            case "bunch_invoices_plugin":
                return BunchInvoicesTab(data);
            case "cash_registers_plugin":
                return CashRegistersTab();
            case "disposal_registrar_plugin":
                return DisposalRegistrarTab();
            case "employee_plugin":
                return EmployeeTab();
            case 'kiz_mark_plugin':
                return KizMarkTab(data);
            case "bunch_db_plugin":
                return BunchDbTab();
            case "additional_settings_plugin":
                return SettingsAdditionalTab();
            case "users_plugin":
                return UserTab();
            case "role_plugin":
                return RoleTab();
            case "companies_plugin":
                return CompaniesTab();
            case "cheque_view_plugin":
                return ChequeTab();
            case "cheque_plugin":
                return ChequeGridTab();
            case "cheque_item_plugin":
                return ChequeItemTab();
            case "cheque_kiz_plugin":
                return ChequeKizTab();
            case "cheque_kiz_mark_plugin":
                return ChequeKizMarkTab();
            case "movement_plugin":
                return MovementTab();
            case "movement_items_plugin":
                return MovementItemsTab();
            case "movement_creator_plugin":
                return MovementCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "movement_from_request_creator_plugin":
                return MovementFromRequestCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "movement_creation_view":
                return MovementCreationTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "unit_plugin":
                return UnitTab();
            case "act_revaluation_plugin":
                return ActRevaluationTab();
            case "act_revaluation_creator_plugin":
                return ActRevaluationCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "act_revaluation_item_plugin":
                return ActRevaluationItemTab();
            case "act_disassembling_plugin":
                return ActDisassemblingTab();
            case "act_disassembling_creator_plugin":
                return ActDisassemblingCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "act_disassembling_item_plugin":
                return ActDisassemblingItemTab();
            case "cash_session_plugin":
                return CashSessionTab();
            case "act_disagregation_plugin":
                return ActDisagregationTab();
            case "act_disagregation_creator_plugin":
                return ActDisagregationCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "act_disagregation_item_plugin":
                return ActDisagregationItemTab();
            case "defectura_plugin":
                return DefecturaTab(variant, singleRender);
            case "discount_condition_type_plugin":
                return ConditionTab();
            case "discount_plugin":
                return DiscountProgramFormTab();
            case "discount_program_creator_plugin":
                return DiscountProgramTab(variant, idGlobal, parentCallback);
            case "invoice_settings_creator":
                return InvoiceSettingsCreatorTab(data, variant, idGlobal, parentCallback);
            case "reports_list_creator_plugin":
                return ReportListCreatorTab(data);
            case "pricing_formula_plugin":
                return PricingFormulaTab();
            case "discount_card_type_plugin":
                return DiscountCardTypeFormTab();
            case "discount_card_plugin":
                return DiscountCardFormTab();
            case "discount_member_plugin":
                return DiscountMemberFormTab();
            case "discount_card_type_creator_plugin":
                return DiscountCardTypeCreatorTab(variant, idGlobal, parentCallback);
            case "discount_card_creator_plugin":
                return DiscountCardCreatorTab(variant, idGlobal, parentCallback);
            case "contractor_tax_type_plugin":
                return ContractorTaxTypePluginTab(data);
            case "system_test_plugin":
                return SystemTestViewPluginTab(data);
            case "kiz_files_plugin":
                return KizFilesViewPluginTab(data);
            case "label_designer_plugin":
                return LabelDesignerTab();
            case "label_designer_template_plugin":
                return LabelDesignerTemplateTab();
            case "label_print_scenario_plugin":
                return LabelPrintScenarioTab()
            case "label_print_scenario_items_plugin":
                return LabelPrintScenarioItemsTab()
            case "loyalty_program_plugin":
                return LoyaltyProgramTab()
            case "invoice_out_plugin":
                return InvoiceOutTab();
            case "invoice_out_item_plugin":
                return InvoiceOutItemTab();
            case "invoice_out_creator_plugin":
                return InvoiceOutCreatorTab(variant, idGlobal ?? uuidv4(), parentCallback, data);
            case "import_remains_plugin":
                return ImportRemainsTab();
            case "import_remains_item_plugin":
                return ImportRemainsItemTab();
            case "global_import_invoices_plugin":
                return GlobalImportInvoicesTab();
            case "imported_invoice_item_plugin":
                return ImportedInvoiceItemTab();
            case "import_remain_plugin":
                return ImportRemainTab();
            case "import_external_report_plugin":
                return ImportExternalReportTab();
            case 'import_market_contract_plugin':
                return ImportMarketContractTab();
            case "import_remains_creator_plugin":
                return ImportRemainsCreatorTab(variant, idGlobal, parentCallback, data);
            case "import_remains_item_creator_plugin":
                return ImportRemainsItemCreatorTab(data, parentCallback);
            case "task_program_plugin":
                return TaskProgramFormTab();
            case "task_program_item_plugin":
                return TaskProgramItemTab();
            case "about_plugin":
                return AboutTab();
            case "test_pricing_model_plugin":
                return TestPricingModelTab();
            case "gos_contract_plugin":
                return GosContractTab();
            case "gos_contract_create_plugin":
                return GosContractCreateTab(variant, idGlobal, parentCallback);
            case "gos_contract_items_plugin":
                return GosContractItemsTab();
            case "goods_kind_plugin":
                return GoodsKindFormTab();
            case "goods_groupByGood_plugin":
                return GoodsGroupByGoodTab();
            case "gos_contract_funding_source_plugin":
                return GosContractFundingSourceTab();
            case "user_action_log_plugin":
                return UserActionLogTab();
            case "barcode_plugin":
                return BarcodeTab();
            case "barcode_grid_view_plugin":
                return BarcodeGridViewTab();
            case "register_price_plugin":
                return RegisterPriceTab();
            case "constructor_schemes_view_plugin":
                return ConstructorSchemesTab();
            case "constructor_schemes_plugin":
                return ConstructorSchemesTab();
            case "act_return_to_contractor_plugin":
                return ActReturnToContactorTab();
            case "act_return_to_contractor_item_plugin":
                return ActReturnToContractorItemTab();
            case "act_return_to_contractor_create_plugin":
                return ActReturnToContactorCreateTab(variant, idGlobal ?? uuidv4(), parentCallback, data);
            case "act_deduction_plugin":
                return ActDeductionTab();
            case "act_deduction_item_plugin":
                return ActDeductionItemTab();
            case "act_deduction_creator_plugin":
                return ActDeductionCreatorTab(variant, idGlobal ?? uuidv4(), parentCallback, data);
            case "access_point_plugin":
                return AccessPointTab();
            case "user_local_plugin":
                return UserLocalTab();
            case "role_local_plugin":
                return RoleLocalTab();
            case "inventory_ved_plugin":
                return InventoryVedGridTab();
            case "inventory_ved_create_plugin":
                return InventoryVedFormTab(variant, idGlobal, parentCallback, data);
            case "inventory_ved_item_create_plugin":
                return InventoryVedItemFormTab(idGlobal ?? null, data, variant, parentCallback);
            case "inventory_ved_item_plugin":
                return InventoryVedItemGridTab();
            case "inventory_sved_plugin":
                return InventorySvedGridTab();
            case "inventory_sved_create_plugin":
                return InventorySvedCreatorTab(variant, idGlobal, parentCallback, data);
            case "inventory_sved_item_plugin":
                return InventorySvedItemTab();
            case "kiz_inventory_plugin":
                return KizInventoryGridTab();
            case "kiz_inventory_item_problem_plugin":
                return KizInventoryItemProblemTab();
            case "kiz_inventory_item_511_schema_plugin":
                return KizInventoryItem511SchemaTab();
            case "kiz_inventory_item_552_schema_plugin":
                return KizInventoryItem552SchemaTab();
            case "kiz_inventory_item_plugin":
                return KizInventoryItemTab();
            case "kiz_inventory_item_sub_plugin":
                return KizInventoryItemSubTab();
            case "kiz_inventory_item_add_plugin":
                return KizInventoryItemAddTab();
            case "kiz_inventory_item_mis_plugin":
                return KizInventoryItemMisTab();
            case "kiz_inventory_item_old_plugin":
                return KizInventoryItemOldTab();
            case "kiz_inventory_item_correct_status_plugin":
                return KizInventoryItemCorrectStatusTab();
            case "kiz_inventory_create_plugin":
                return KizInventoryCreatorTab(variant, idGlobal, parentCallback, data);
            case "internet_order_plugin":
                return InternetOrderTab();
            case "internet_order_create_plugin":
                return InternetOrderCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "internet_order_item_plugin":
                return InternetOrderItemsTab();
            case "locking_documents_plugin":
                return LockingDocumentsTab();
            case "sys_options_plugin":
                return SysOptionsTab();
            case "sys_options_detail_plugin":
                return SysOptionsDetailTab();
            case "es_code_plugin":
                return EsCodeViewPluginTab(data);
            case "company_active_sessions_plugin":
                return CompanyActiveSessionsTab();
            case "virtualized_options_plugin":
                return VirtualizedTab();
            case "connection_settings_f3llo_plugin":
                return ConnectionSettingsF3lloTab();
            case "connection_settings_f3bus_plugin":
                return ConnectionSettingsF3busTab();
            case "connection_settings_marketing_plugin":
                return ConnectionSettingsMarketingEventsTab();
            case "base_photo_download_plugin":
                return BasePhotoDownloadTab();
            case "create_default_plugin_settings":
                return CreateDefaultPluginSettingsTab();
            case "access_point_detail_plugin":
                return AccessPointDetailTab();
            case "basic_settings_plugin":
                return BasicSettingsTab();
            case "settings_offline_plugin":
                return SettingsOfflineTab();
            case "setting_time_plugin":
                return SettingTimeTab();
            case "product_groups_gismt_plugin":
                return ProductGroupsGISMTTab();
            case "reg_keys_list_plugin":
                return RegKeysListTab();
            case "falsificat_plugin":
                return FalsificatTab();
            case "request_for_movement_plugin":
                return RequestForMovementTab();
            case "request_for_movement_create_plugin":
                return RequestForMovementCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case "request_for_movement_item_plugin":
                return RequestForMovementItemsTab();
            case "request_for_movement_party_plugin":
                return RequestForMovementPartyTab();
            case "invoice_cash_order_plugin":
              return InvoiceCashOrderTab();
            case "invoice_cash_order_create_plugin":
              return InvoiceCashOrderCreatorTab(idGlobal ?? uuidv4(), variant, parentCallback, data);
            case 'export_1C_plugin':
                return Export1CTab();
            case "export_1c_procedure_plugin":
                return Export1CProcedureTab();
            case 'export_document_tools_create_plugin':
                return ExportDocumentToolsCreateTab(variant,idGlobal);
            case 'export_document_tools_model_plugin':
                return ExportDocumentToolsTab();
            case 'marketing_events_plugin':
                return MarketingEventsTab();
            case 'marketing_events_products_plugin':
                return MarketingEventsProductsTab();
            case 'marketing_events_planDepartments_plugin':
                return MarketingEventsPlanDepartmentsTab();
            case 'marketing_events_factDepartments_plugin':
                return MarketingEventsFactDepartmentsTab();
            case 'marketing_events_distributors_plugin':
                return MarketingEventsDistributorsTab();
            case 'marketing_events_departments_plugin':
                return MarketingEventsDepartmentsTab();
            case 'marketing_compensated_discounts_plugin':
                return MarketingCompensatedDiscountsTab();
            case 'marketing_compensated_discounts_products_plugin':
                return MarketingCompensatedDiscountsProductsTab();
            case 'news_maker_plugin':
                return NewsMakerTab();
            case 'categorical_group_plugin':
                return CategoricalGroupTab();
            case 'marketing_bonus_calculator_plugin':
                return MarketingBonusCalculatorTab();
            default:
                throw Error(`Not implemented: ${plugin}`);
        }
    }
}

export default MasterTabsProvider;
